// Shows a proof file: images inline, PDFs in a frame, anything else as a
// download link. Used by the rep's Send to client screen and the client's
// review page (Stephanie 2026-10-12).
export function ProofPreview({ file }: { file: { url: string | null; name: string; mimeType: string } | null }) {
  if (!file?.url) return <p className="rounded-md border border-rule bg-canvas p-6 text-center text-sm text-muted">The proof file can't be shown here.</p>;
  if (file.mimeType.startsWith("image/")) {
    return <img src={file.url} alt={`Proof: ${file.name}`} className="max-h-[70vh] w-full rounded-md border border-rule bg-white object-contain" />;
  }
  if (file.mimeType === "application/pdf") {
    return <iframe src={file.url} title={`Proof: ${file.name}`} className="h-[70vh] w-full rounded-md border border-rule bg-white" />;
  }
  return (
    <a href={file.url} download={file.name} className="block rounded-md border border-rule bg-white p-6 text-center text-ink underline underline-offset-4">
      Download {file.name}
    </a>
  );
}
